module.exports = __webpack_public_path__ + "assets/img/icon_phone.b4f71097.jpg";